import React, { useEffect, useState } from 'react';
import { FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useHistory, Link } from 'react-router-dom';
import { Constants } from '../endPoints';

export default function Login() {
  const history = useHistory();
  const backgroundImageUrl = 'assets/images/bg-02.jpg';
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [resetModal, setResetModal] = useState(false);
  const [resetUsername, setResetUsername] = useState('');

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMsg, setResetMsg] = useState('');
  const [error, setError] = useState(false);

  const resetOpen = () => setResetModal(true);
  const resetClose = () => setResetModal(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(Constants.userLogin, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.message || 'Login failed, please try again.');
        return;
      }

      const data = await response.json();
      localStorage.setItem('authToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      history.push('/dashboard');
      window.location.reload();
    } catch (error) {
      alert('A network error occurred. Please try again later.');
    }
  };

  useEffect(() => {
  if (error && resetMsg) {
    const timer = setTimeout(() => {
      setResetMsg('');
      setError(false);
    }, 3000);
    return () => clearTimeout(timer);
  }
}, [error, resetMsg]);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setResetLoading(true);
    setResetMsg('');
    setError(false);
    try {
      const response = await fetch(Constants.forgotPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resetUsername }),
      });
      const data = await response.json();
      setError(!response.ok || data.success === 0);
      setResetMsg(data.message || 'If an account exists, a reset link has been sent.');
    } catch (err) {
      setError(true);
      setResetMsg('Something went wrong. Please try again.');
    } finally {
      setResetLoading(false);
    }
  };


  return (
    <>
      <section className='bgleft loginsec relative min-h-screen mt-20'>
        <div className='mx-auto loginpnel min-h-screen align-items-center'>
          <Grid container columns={12} spacing={0} className='overflow-hidden h-full min-h-screen'>
            <Grid
              item
              lg={6}
              sm={12}
              xs={12}
              style={{ backgroundImage: `url(${backgroundImageUrl})` }}
              className='loginleft bg-cover bg-right-top table'
            >
              {/* <div className='align-middle table-cell py-10 relative boxlayer'>
                <div className='absolute top-0 left-0 w-full h-full bg-[#ffffff21]'></div>
                <Grid container spacing={3} className='justify-center'>
                  <Grid item lg={6}>
                    <div className='text-center relative z-[1]'>
                      <img src={`${process.env.PUBLIC_URL}/assets/images/logo.svg`} className='mx-auto h-20' alt="Logo" />
                    </div>
                  </Grid>
                </Grid>
              </div> */}
            </Grid>

            <Grid item lg={6} sm={12} xs={12} className='table loginright'>
              <div className='align-middle table-cell py-14 px-6'>
                <div  >
                  <Grid item xl={6} lg={7} md={8} xs={12} className="pageheading-wrapper">
                    <div className='pagehding'>
                      <h2 className='mb-8 text-4xl font-semibold text-center headningfont'>Log In</h2>
                    </div>

                    <form onSubmit={handleLogin} autoComplete="off">
                      <div
                        className="loginacunt"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          flexWrap: "wrap"
                        }}
                      >
                        <p style={{ fontSize: "17px", margin: 0 }}>
                          Do not have an account?
                        </p>
                        <Link style={{ fontSize: "18px" }} to="/register">
                          Join Create Account
                        </Link>
                      </div>
                      <div className='logindata'>
                        <TextField
                          label="Email"
                          variant="outlined"
                          className='w-full rounded-lg'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          autoComplete="new-email"
                          inputProps={{
                            autoComplete: "new-email"
                          }}
                        />
                      </div>

                      <div className='logindata'>
                        <FormControl variant="outlined" className='w-full'>
                          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            autoComplete="new-password"   // ✅ important
                            inputProps={{
                              autoComplete: "new-password"
                            }}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            }
                            label="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </FormControl>
                      </div>

                      <div className='loginforgot'>
                        <a
                          type="button"
                          onClick={resetOpen}
                          className="text-[#A27800] font-semibold underline"
                        >
                          Forgot Your Password?
                        </a>
                      </div>

                      <div className='loginbutn'>
                        <button type="submit" className='submit_btn'>Login</button>
                      </div>


                    </form>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      {/* Custom Modal */}
      {resetModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <h2 className='md:text-2xl text-xl font-bold text-center mb-5'>Forgot password</h2>
            <p className='text-center mb-10'>Enter your registered email address to reset your password.</p>
            <form onSubmit={handleForgotPassword}>
              <div className='mb-5'>
                <TextField
                  label="Email"
                  variant="outlined"
                  className='w-full rounded-lg'
                  value={resetUsername}
                  onChange={(e) => setResetUsername(e.target.value)}
                  required
                  type="email"
                />
              </div>
              {resetMsg && (
                <p
                  className='text-center mb-3'
                  style={{
                    color: error ? '#a20000ff' : '#0b6b3a',
                    background: error ? '#fdecea' : '#e6f4ea',
                    border: `1px solid ${error ? '#f5c2c0' : '#b7e1c3'}`,
                    borderRadius: '6px',
                    padding: '10px 14px',
                    fontWeight: 500,
                  }}
                >
                  {resetMsg}
                </p>
              )}
              <div className="mb-5">
                <button
                  type="submit"
                  className="link_btn w-full"
                  disabled={resetLoading}
                  style={{ color: '#A27800', fontWeight: 500 }}
                >
                  {resetLoading ? 'Sending...' : 'Send'}
                </button>
              </div>
            </form>
            <div className='text-center'>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); resetClose(); }}
                className="text-[#A27800] underline font-semibold"
                style={{ color: '#A27800', fontWeight: "500", textDecoration: 'underline' }}
              >
                Close
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}